import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center font-anton text-2xl uppercase">
        Loading…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  }
  return children;
}
